'use strict';

angular.module('amexReconciliationApp')
  .directive('uploadReceiptToCycleButton', function () {
    return {
      templateUrl: 'scripts/views/directives/upload-receipt-to-cycle-button.html' ,
      bindToController: {
        uploadSuccess: '@',
        uploadFailure: '@',
        receiptTooLarge: '@',
        currentBillingCycle: '<',
        refreshReceipts: '='
      },
      controllerAs: 'UploadReceiptToCycleButtonController',
      controller: function (ReceiptRepository, toastr, $rootScope, $uibModal) {
        var self = this;

        self.isUploading = false;

        self.uploadReceipts = function uploadReceipts(receipts) {
          if (receipts && receipts.length) {
            if (receipts.length == 1) {
              openReceiptDetailsModal(receipts);
            } else {
              uploadMultipleReceipts(receipts);
            }
          }
        };

        self.validateReceipt = function(receipt) {
          if (receipt.size > 5242880) {
            toastr.error(receipt.name + ' ' + self.receiptTooLarge);
            return false;
          }
        };

        function uploadMultipleReceipts(receipts) {
          self.isUploading = true;
          var receiptsObject = _.map(receipts,function(receipt) {return {file: receipt, details: {}};});
          ReceiptRepository.upload(receiptsObject, self.currentBillingCycle)
            .then(function () {
              toastr.success(self.uploadSuccess);
            }).catch(function (error) {
              toastr.error(error || self.uploadFailure);
            }).finally(function () {
              self.isUploading = false;
              if (self.refreshReceipts) {
                self.refreshReceipts();
              }
            });
        }

        function openReceiptDetailsModal(receipts) {
          var scopeWithReceipts = $rootScope.$new();
          scopeWithReceipts.receipts = receipts;
          scopeWithReceipts.uploadSuccess = self.uploadSuccess;
          scopeWithReceipts.uploadFailure = self.uploadFailure;
          scopeWithReceipts.currentBillingCycle = self.currentBillingCycle;
          scopeWithReceipts.refreshReceipts = self.refreshReceipts;

          $uibModal.open({
            template: '<receipt-details-modal ' +
            'receipts="receipts" ' +
            'upload-success="uploadSuccess" ' +
            'upload-failure="uploadFailure" ' +
            'current-billing-cycle="currentBillingCycle" ' +
            'refresh-receipts="refreshReceipts" ' +
            'close-modal-callback="$close()">' +
            '</receipt-details-modal>',
            size: 'md',
            scope: scopeWithReceipts
          });
        }
      }
    };
  });





//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/directives/uploadReceiptToCycleButton.js
// module id = 542
// module chunks = 0